import { Taxonomy, User, OrganisationDto } from '@treetop/shared/model';

export enum ClusterContentTab {
  Guidelines = 'Guidelines',
  Chapters = 'Chapters',
}

export enum ShareState {
  Pending,
  Accepted,
  Denied,
}

export type SelectedGuideline = {
  id: string;
  title: string;
};

export type RemoveConnectedOrganisationEvent = {
  id: string;
  organisationDisplayName: string;
};

export type RemoveOutgoingShareEvent = {
  id: string;
  organisationDisplayName: string;
};

export type OrganisationConnection = {
  id: string;
  fromOrganisationId: string;
  fromOrganisation: OrganisationDto;
  toOrganisationId: string;
  toOrganisation: OrganisationDto;
  createdById: string;
  createdBy: User;
  acceptedById: string;
  acceptedBy: User;
  createdAt: string;
  acceptedAt: string;
};

export type BaseShare = {
  id: string;
  organisationId: string;
  organisation: OrganisationDto;
  sharedForOrganisationId: string;
  sharedForOrganisation?: OrganisationDto;
  sharedByUserId: string;
  sharedByUser?: User;
  sharedAt: string;
  statusChangedByUserId: string | null;
  statusChangedByUser: User | null;
  statusChangedAt: string | null;
  state: ShareState;
  includeAttachments: boolean;
  allowLocalChanges: boolean;
  automaticUpdates?: boolean;
  forwardEmailNotifications?: boolean;
};

export type GuidelineShareRelation = {
  guidelineShareId: string;
  guidelineUniqueId: string;
};

export type ChapterShare = BaseShare & {
  allChapters: boolean;
  selectedChapters: Taxonomy[];
  pushNewContent: boolean;
};

export type GuidelineShare = BaseShare & {
  selectedGuidelines: GuidelineShareRelation[];
};

export type Share = GuidelineShare | ChapterShare;
